module.exports = __webpack_public_path__ + "static/media/calendar-icon.b216768f.svg";